import React from "react";

/**
 * Unicode component
 * Usage: <Unicode code="1F511" /> → 🔑
 */
const Unicode = ({ code }) => {
  try {
    // Handle both hex ("1F511") and decimal ("128273")
    const value = code.startsWith("U+")
      ? code.slice(2)                // "U+1F511" → "1F511"
      : code;

    const char = String.fromCodePoint(parseInt(value, 16));

    return <span>{char}</span>;
  } catch (e) {
    console.error("Invalid Unicode code:", code);
    return <span>�</span>; // replacement character
  }
};

export default Unicode;